<section>
  <app-header></app-header>
  <app-home *ngIf="isHome"></app-home>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
  <app-footer *ngIf="isContactUs"></app-footer>
</section>

<div class="position-fixed d-none d-md-block" id="web-fab" *ngIf="isFabs"
  style="top:40%;right: 0;z-index: 99;box-shadow: 0 6px 10px 0 #666;border-radius:25px">
  <ul role="list" style="list-style: none;border-bottom-left-radius: 20px;border-top-left-radius: 20px;"
    class="primaryBackgroundColor mb-0 pl-0">
    <div class="px-3 py-2">
      <li class="text-center py-1">
        <a href="tel:01179 567603" aria-label="01179 567603" class="d-flex align-items-center number-view"
          style="text-decoration: none;">
          <img loading="lazy" src="{{videoCdnUrl}}images/phone.svg" alt="phone" height="25" width="25">
          <p class="mb-0 pr-3 pl-3 btn btn-primary">01179 567603</p>
        </a>
      </li>
      <li class="text-center py-1" style="text-decoration: none;">
        <a routerLink="/Emergency Contact Us" aria-label="Emergency" class="d-flex align-items-center number-view">
          <img loading="lazy" src="{{videoCdnUrl}}images/emergencyBlack.svg" alt="emergency" height="35" width="35">
          <p class="mb-0 pr-3 pl-3 btn btn-primary">Emergency</p>
        </a>
      </li>
      <li class="text-center py-1" style="text-decoration: none;">
        <a (click)="BookAppointment()" aria-label="Book an appointment"
          class="d-flex align-items-center number-view">
          <img loading="lazy" src="{{videoCdnUrl}}images/appointment-form.svg" alt="appointment" height="30" width="30">
          <p class="mb-0 pr-3 pl-3 btn btn-primary">Book an appointment</p>
        </a>
      </li>
    </div>
    <div style="border-top: 1px solid gray;" class="px-3 py-2">
      <li class="text-center py-1">
        <a (click)="shareOnWhatsapp()" aria-label="Share this page on" target="_blank"
          class="d-flex align-items-center number-view">
          <img loading="lazy" src="{{videoCdnUrl}}images/whatsapp.svg" alt="whatsapp" height="35" width="35">
          <p class="mb-0 pr-3 pl-3 btn btn-primary">Share this page on</p>
        </a>
      </li>
      <li class="text-center py-1">
        <a (click)="showMailPopup()" aria-label="Share this page on" class="d-flex align-items-center number-view">
          <img loading="lazy" src="{{videoCdnUrl}}images/email.svg" alt="email" height="35" width="35">
          <p class="mb-0 pr-3 pl-3 btn btn-primary">Share this page on</p>
        </a>
      </li>
    </div>

  </ul>
</div>

<!-- <div class="dropdown chat-fab position-fixed " *ngIf="isFabs">
  <div class="text-center rounded-circle" data-toggle="tooltip" data-placement="left"
    style="box-shadow: 0 6px 10px 0 #666;" title="Chat">
    <a data-toggle="collapse" href="#whatsapp-chat-popup" aria-label="Chat" role="button" aria-expanded="false"
      aria-controls="chat-popup">
      <img loading="lazy" src="{{videoCdnUrl}}images/whatsapp-chat.svg" alt="chat" height="50" width="50">
    </a>
  </div>
</div> -->

<div class="fab position-fixed d-sm-block d-md-none" *ngIf="isFabs">
  <a class="dropdown-toggle w-100 rounded-circle greenBackgroundColor fab-btn" id="dropdownMenuButton"
    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    <img loading="lazy" src="{{videoCdnUrl}}images/plusWhite.svg" alt="plus" height="25" width="35"
      class="text-center" />
  </a>
  <div class="dropdown-menu w-100 dropdown-menu-right transperantBackgroundColor"
    style="background-color: #ffffff00;border:none;transform: translate3d(-100px, -150px, 0px) !important;min-width: auto;"
    aria-labelledby="dropdownMenuButton">
    <a class="dropdown-item p-0 fab-item" style="background-color: #ffffff00;border:none">
      <ul role="list" style="list-style: none;background-color: #ffffff00" class="primaryBackgroundColor p-3">
        <li class="text-center mb-3">
          <a href="tel:01179 567603" aria-label="01179 567603" class="rounded-circle p-3 greenBackgroundColor fab-btn">
            <img loading="lazy" src="{{videoCdnUrl}}images/phoneWhite.svg" alt="phone-white" class="mt-2 mb-2"
              height="25" width="20">
          </a>
        </li>
        <li class="text-center mb-3">
          <a routerLink="/Emergency Contact Us" aria-label="Emergency Contact Us"
            class="rounded-circle greenBackgroundColor fab-btn">
            <img loading="lazy" src="{{videoCdnUrl}}images/alarmWhite.svg" alt="alarmWhite" class="mb-2" height="25"
              width="35">
          </a>
        </li>
        <li class="text-center mb-3" style="margin-bottom: -10px;">
          <a (click)="BookAppointment()" aria-label="Book An Appointmet"
            class="rounded-circle p-3 greenBackgroundColor fab-btn">
            <img loading="lazy" src="{{videoCdnUrl}}images/appointment-form.svg" alt="appointment-form"
              class="mt-2 mb-2" height="25" width="20">
          </a>
        </li>
        <li class="text-center mb-3" style="margin-bottom: -10px;">
          <a href="https://api.whatsapp.com/send?text={{whatsappUrl}}" target="_blank"
            class="rounded-circle p-3 greenBackgroundColor fab-btn" rel="noopener" aria-label="whatsapp share">
            <img loading="lazy" src="{{videoCdnUrl}}images/whatsapp.svg" alt="whatsapp" class="mt-2 mb-2" height="25"
              width="20">
          </a>
        </li>
        <li class="text-center" style="margin-bottom: -10px;">
          <a (click)="showMailPopup()" class="rounded-circle p-3 greenBackgroundColor fab-btn" aria-label="email share">
            <img loading="lazy" src="{{videoCdnUrl}}images/email.svg" alt="email" class="mt-2 mb-2" height="25"
              width="20">
          </a>
        </li>
      </ul>
    </a>
  </div>
</div>



<div id="whatsapp-chat-popup" class="chat-popup collapse">
  <div class="text-left w-100 px-3 py-2 greenBackgroundColor" style="height: 50px;">
    <img loading="lazy" src="{{videoCdnUrl}}images/avatar.svg" alt="Marketing Representative" class="cursor mr-3"
      height="30" width="30">
    <span class="whiteColor">Marketing Representative</span>
    <img loading="lazy" data-toggle="collapse" href="#whatsapp-chat-popup" src="{{videoCdnUrl}}images/close.svg"
      alt="close" aria-label="Close" class="cursor ml-3" height="15" width="15">
  </div>
  <div class="p-3" id="welcomePopup" style="background: url({{videoCdnUrl}}images/whatsapp-background.png);">
    <h3 class="primaryColor mb-3 text-center">Welcome to {{title}}</h3>

    <div class="WhatsappChat" style="opacity: 1;">
      <div class="WhatsappChat">Marketing Consultant</div>
      <div class="WhatsappChat">Hi there 👋<br>How can I help you?</div>
    </div>
  </div>
  <button class="btn m-auto rounded w-100" style="background-color: #00cc67;color: white;" (click)="openWhatsappChat()"
    aria-label="Start Chat">Start Chat</button>
</div>

<div class="modal fade" id="ModalEmail" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <p>Share this information via email..</p>
        <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close" (click)="resetModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="">
          <form [formGroup]="composeForm" class="mt-3" id="composeForm" *ngIf="IsLoggedInUserName">
            <div class="form-group">
              <input type="text" placeholder="Sender's Name" class="form-control" formControlName="senderName" required
                [ngClass]="{'red-border-class':composeFormSubmitted && composeForm.controls['senderName'].errors}">
            </div>
            <div class="form-group">
              <input type="text" placeholder="Reciever's Name" class="form-control" formControlName="recieverName"
                required
                [ngClass]="{'red-border-class':composeFormSubmitted && composeForm.controls['recieverName'].errors}">
            </div>
            <div class="form-group">
              <label>Reciever's Email ID</label>
              <input type="text" rows="2" id="emailsNew" class="form-control w-100" required
                [ngClass]="{'red-border-class':composeFormSubmitted && composeForm.controls['mailTo'].errors}"
                placeholder="Enter a email id. For example: john.smith@gmail.com;" formControlName="mailTo">
            </div>
            <div class="form-group">
              <label>Would you like add note? (optional)</label>
              <textarea rows="2" id="notes" class="form-control w-100"
                [ngClass]="{'red-border-class':composeFormSubmitted && composeForm.controls['notes'].errors}"
                placeholder="Enter notes " formControlName="notes"></textarea>
            </div>
            <div class="text-right w-100">
              <button type="button" id="sendMail" aria-label="send email" class="btn btn-success mt-2 mr-2"
                (click)="sendMail()" value="SEND">Send</button>
              <button type="button" id="cancelEmail" data-dismiss="modal" class="btn btn-danger mt-2"
                (click)="cancelEmail()" value="CANCEL" aria-label="cancel">Cancel</button>
            </div>
          </form>

          <div id="emailSubject" style="opacity: 0;height: 0;width: 0;visibility: hidden;">
            [LoggedInUserName] has recommended something interesting for you
          </div>

          <!-- <div class="primaryBackgroundColor p-2" id="emailBody"
            style="opacity: 0;height: 0;width: 0;visibility: hidden;">
            <p>Hi [RecieverName],</p>
            <p>This is <strong>[LoggedInUserName]</strong>. Whilst browsing the Smile Orchard website, I found something
              interesting and thought you might like it: </p>
            <p>[Notes]</p>
            <a href={{websiteUrl}}{{currentUrl}} target="_blank" aria-label="Smile Orchard"
              rel="noopener">{{websiteUrl}}{{currentUrl}}</a>
            <p class="mt-4 mb-1">Thanks and Regrads</p>
            <p style="margin-bottom: 8px;">Smile Orchard</p>
            <img loading="lazy" src="https://liveapi.smileorchard.co.uk/SOLogoL2_300.jpg" alt="Smile Orchard"
              class="img-fluid">
          </div> -->

          <div class="primaryBackgroundColor p-2" id="emailBody"
            style="opacity: 0;height: 0;width: 0;visibility: hidden;">
            <p>Hi [RecieverName],</p>
            <p>For more information on the service you are interested in, please click link below. </p>
            <a href={{websiteUrl}}{{currentUrl}} target="_blank" aria-label="Smile Orchard"
              rel="noopener">{{websiteUrl}}{{currentUrl}}</a>
            <p>[Notes]</p>
            <p style="margin-top: 20px;margin-block-start: 5px;margin-block-end: 5px;">Kind regards,</p>
            <p style="margin-top: 20px;margin-block-start: 0px;">[LoggedInUserName]</p>
            <div style="margin-left: 5px;">
              <p>Smile Orchard<br>
                Bristol - BS16 1NU<br>Ph<a href="tel:0117 956 7603"> 0117 956 7603 </a><br>
                Email <a href="mailTo:info@smileorchard.co.uk">info@smileorchard.co.uk </a><br>
                Website <a href="https://www.smileorchard.co.uk" target="_blank" rel="noopener"> www.smileorchard.co.uk
                </a><br></p>

            </div>
          </div>

          <div *ngIf="isSuccess" class="text-center">
            <img loading="lazy" src="{{videoCdnUrl}}images/right.svg" height="50" width="50" alt="right" />
            <p class="primaryColor">Success</p>
            <p>Thank you for sharing this information via email.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>